import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  private readonly ALL_KEYS = [
    'cartItems',
    'categories',
    'totalQuantity',
    'projectType',
    'projectDescription',
    'remarks',
    'fromSummary',
    'isEditingOrder',
    'originalProjectDescription',
    'originalProjectType',
    'originalRemarks',
    'originalProjectCostCenter'
  ];

  private readonly SUMMARY_KEYS = [
    'cartItems',
    'totalQuantity',
    'projectDescription',
    'remarks',
    'projectType',
    'fromSummary'
  ];

  clearAll(): void {
    this.ALL_KEYS.forEach(key => localStorage.removeItem(key));
  }

  clearSummary(): void {
    this.SUMMARY_KEYS.forEach(key => localStorage.removeItem(key));
  }
}
